<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item>
           <!-- :label="$t('lang.lab_RegTime')" -->
          <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="'注册'+$t('lang.lab_startDate')"
            :end-placeholder="'注册'+$t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value=''></el-option>
            <el-option
              v-for="(item,index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value=''></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value=''></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份 -->
        <!-- <br> -->
        <el-form-item>
          <el-select
            class="select"
            v-model="user"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')">
              <el-option
              v-for="item in Identitys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
          <!-- 标签 -->
        <el-form-item>
          <el-select
            class="select"
            v-model="draw"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.TAGS[0].label')"
            @change="changeDraw($event)">
              <el-option
              v-for="item in tags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <!-- 其他标签 -->
        <el-form-item>
          <el-input class="seachInput" v-if="showQt" v-model="qt" placeholder="请输入标签内容"></el-input>
        </el-form-item>  
        <!-- 关键字 -->
        <el-form-item>
          <el-input class="seachInput" v-model="keyword" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"></el-input>
        </el-form-item>       
          <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- 用户名 -->
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="garden.name" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column prop="garden.grids.houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column prop="garden.grids.unitName" :label="$t('lang.lab_unitnum')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="garden.grids.roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 身份 -->
        <el-table-column prop="garden.userType" :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.garden.userType === 1"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 2"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')}}</span>
            <span
              v-if="scope.row.garden.userType === 3"
            >{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')}}</span>
          </template>
        </el-table-column>
        <!-- 标签 -->
        <el-table-column prop="draw" :label="$t('lang.lab_tags')">
          <template slot-scope="scope" v-if="scope.row.drawUserGarden!=''">
            <el-tooltip placement="top" effect="light" v-if="scope.row.drawUserGarden&&scope.row.drawUserGarden.length>30"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.drawUserGarden }}
                </span>
              </div>
              <div>
                {{ scope.row.drawUserGarden.substring(0, 30) | valueIsNull }}
                <span v-if="scope.row.drawUserGarden.length>30">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.drawUserGarden | valueIsNull }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" v-else>
            <el-tooltip placement="top" effect="light" v-if="scope.row.draw&&scope.row.draw.length>30"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.draw }}
                </span>
              </div>
              <div>
                {{ scope.row.draw.substring(0, 30) | valueIsNull }}
                <span v-if="scope.row.draw.length>30">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.draw | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 明星业主 -->
        <!-- <el-table-column prop="starHouseOwner" :label="$t('lang.lab_starHouseOwner')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.starHouseOwner === 1"
            >{{$t('lang.lab_isYes')}}</span>
            <span
              v-else
            >{{$t('lang.lab_isNo')}}</span>
          </template>
        </el-table-column> -->
         <el-table-column prop="staffName" :label="$t('lang.lab_housekeeper')" width="200"></el-table-column>
        
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width4">
            <template slot-scope="scope">
              <el-button @click="change(scope.row)">{{$t('lang.btn_modify')}}</el-button>
              <el-button class="orange" @click="del(scope.row)">{{$t('lang.btn_delete')}}</el-button>
              <el-button @click="toggleIsShop(scope.row)">{{ scope.row.isShop == 1 ? '取消商家' : '成为商家' }}</el-button>
              <el-button  @click="goPortrait(scope.row)">业主画像</el-button>
            </template>
          </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
    </el-card>
  </div>
</template>

<script>
// 引入富文本title汉字
import { excelDownload } from '../../../config/download.js'
/**
 *@ClassName:appHouseholdManage
 *@Description:app住户管理
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.user',
    data() {
      return {
      multipleSelection: [], // 多选框
      datevalues: [], // 开始结束时间绑定值
      floorid: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '', // 标签
      draw: '', // 标签新
      qt: '', // 标签选其他的标签文本内容
      showQt: false, // 标签文本内容展示状态
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
      tags: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.TAGS'), // 标签列表
      appHouseholdManageListcheckbox: require('@/config/enum').appHouseholdManageListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    activated() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听改变小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.gardenChange()
      }
    },
    methods: {
      // 改变标签
      changeDraw(e) {
        if (e == '其它') {
          this.showQt = true
        } else {
          this.qt = ''
          this.showQt = false
        }
      },
        // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({ row, rowIndex }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 添加多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.lab_unitnum'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_identitynum'),
            this.$i18n.t('lang.lab_tags'),
          ]
          // 对应table数据的列字段名
          let newArr = []
          let userType = ''
          let houseName = ''
          let unitName = ''
          let roomName = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              // 判断楼号单元房间号是否存在
              if (this.tableData[i].garden.grids) {
                houseName = this.tableData[i].garden.grids.houseName
                unitName = this.tableData[i].garden.grids.unitName
                roomName = this.tableData[i].garden.grids.roomName
              }
              // 判断身份
              if (this.tableData[i].garden.userType === 1) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')
              } else if (this.tableData[i].garden.userType === 2) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')
              } else if (this.tableData[i].garden.userType === 3) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')
              }
              newArr.push({
                'nickName': this.tableData[i].nickName,
                'mobile': this.tableData[i].mobile,
                'garden.name': this.tableData[i].garden.name,
                'garden.grids.houseName': houseName,
                'garden.grids.unitName': unitName,
                'garden.grids.roomName': roomName,
                'garden.userType': userType,
                'tag': this.tableData[i].tag
              })
            }
          }
          const filterVal = ['nickName', 'mobile', 'garden.name', 'garden.grids.houseName', 'garden.grids.unitName', 'garden.grids.roomName', 'garden.userType', 'tag'] 
          excelDownload(tHeader, filterVal, newArr, this.$i18n.t('lang.lab_appUsermanagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 改变小区
      gardenChange() {
        this.floorid = ''
        this.topics()
        this.unitid = ''
        this.roomid = ''
        this.unitList = ''
        this.roomList = ''
        this.type = 1
        this.gardenGrids(this.gardenId)
      },
      // 获取楼号单元号房间号
      gardenGrids(parentId) {
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.floorList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
                this.roomList = ''
                if (this.floorid === '') {
                  this.unitList = ''
                  this.roomList = ''
                }
              } else if (this.type === 3) {
                this.roomList = res.list
                if (this.unitid === '') {
                  this.roomList = ''
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 模糊查询
      topics() {
        if (this.draw == '其它' && this.qt == '') {
          this.$message.info('请输入标签内容')
          return false
        }
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        let loading = this.$loading()
        this.$get(
          `/users?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&key=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}&draw=${this.draw}&qt=${this.qt}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      change(row) {
        this.$router.push({ name: 'houseHoldInfo', query: { row: row } })
      },
      del(row) {
        let loading = this.$loading()
        let params = {
              garden: this.gardenId,
              house: row.garden.grids.houseId,
              unit: row.garden.grids.unitId,
              room: row.garden.grids.roomId
            }
        this.$confirm(
          this.$i18n.t('lang.lab_isdelete'),
          this.$i18n.t('lang.lab_prompt'),
          {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }
        ).then(() => {
            this.$post(`users/` + row.id, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.pageNo = 1
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }).catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 业主画像
      goPortrait(row) {
        console.log(row)
        this.$router.push({ name: 'appHouseholdPortrait', query: { row: row } })
      },
      // 提交
      toggleIsShop(row) {
        let targetIsShop = row.isShop == 1 ? 0 : 1
        let loading = this.$loading()
        let params = {
          userId: row.id,
          isShop: targetIsShop
        }
        this.$get('/usersIsShop', params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$set(row, 'isShop', targetIsShop)
              this.$message.success(targetIsShop === 1 ? '成为商家成功' : '取消商家成功')
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 通过楼层选择单元号
      selectUnit() {
        this.type = 2
        this.gardenGrids(this.floorid)
        this.unitid = ''
        this.roomid = ''
      },
      // 通过单元选择房间号
      selectRoom() {
        this.type = 3
        this.gardenGrids(this.unitid)
        this.roomid = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang= 'scss'>
</style>
